<template>

    <v-container>
        <v-row wrap :justify="'space-between'" class="mb-16">
            <v-col md="4">
                <v-card class="rounded-0 tileHint_left" flat >
                    <v-img :src="artists[getPrevious(model, artists.length - 1)].thumbnailImg" :aspect-ratio="1/1"></v-img>
                </v-card>
            </v-col>
            <v-col md="4">
                <v-card class="rounded-0 middle_img" >
                    <v-img :src="artists[model].thumbnailImg" :aspect-ratio="1/1"></v-img>
                </v-card>
            </v-col>
            <v-col md="4" >
                <v-card class="rounded-0 tileHint_right" flat>
                    <v-img :src="artists[getNext(model, artists.length)].thumbnailImg" :aspect-ratio="1/1"></v-img>
                </v-card>
            </v-col>
            <div class="arrow_left">
                <v-btn @click="model > 0 ? model-- : model = (artists.length - 1); updateArtists(model);" icon color=#707070> 
                    <v-icon :size="getIconSize">fas fa-angle-left</v-icon>
                </v-btn>
            </div>
            <div class="arrow_right">
                <v-btn @click="model < artists.length - 1 ? model++ : model = 0; updateArtists(model);" icon color=#1765B3>
                    <v-icon :size="getIconSize">fas fa-angle-right</v-icon>
                </v-btn>
            </div>
        </v-row>
    </v-container>
</template>

<script>


export default {
    name: 'StaffCarousel',
    methods: {
        updateArtists(model) {
            this.$emit('clicked', model)
        },
        getPrevious(model, max) {
            return model > 0 ? model -1 : max;
        }, 
        getNext(model, max) {
            console.log(model + ": " + max);
         return model == (max - 1) ? 0 : (model + 1);
        }
    }, 
    computed: {
        getIconSize () {
            const {smAndDown } = this.$vuetify.breakpoint
            return smAndDown ? 80 : 120
        }
    },
    data() {
        return {
        model: 0,
      }
 
    },
    //  props: ["artists", "model"]
     props: {
            // apple: {
            //     type: Number,
            //     required: true
            // },
                artists: {
                    type: Array
                }
            }
        // watch: {
        //     value() {
        //         this.$emit('input', this.value);
        //     }
        // }
}



</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables.scss';

.tileHint_left {
    position: relative;
    background-color: rgba(0,0,0,0);
    opacity: 1;
    .v-image {
        position: relative;
        left: -50%;
    }
}
.tileHint_right {
    position: relative;
    background-color: rgba(0,0,0,0);
    opacity: 1;
    .v-image {
        position: relative;
        right: -50%;
    }
}
.middle_img  {
            box-shadow: -26px 29px 13px -6px rgba(0,0,0,0.6) !important;
}
.arrow_left {
    
    position: absolute;
    top: 17%;
    left: 21%;
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
        top: 20%;
        left: 22%;
    }
}

.arrow_right {
    position: absolute;
    top: 35% ;
    left: 70%;
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
        top: 56%;
        left: 73%;
    }
}

.seat {
    img {
        width: 100px;
    }
}
</style>